import { css } from "linaria";

/**
 * Visually hidden but accessible to screen readers.
 * Used for live regions, skip links, and sr-only labels.
 */
export const srOnly = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
`;
